import _objectSpread from "/data/landun/workspace/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/data/landun/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue";
var _hoisted_1 = {
  class: "flex-v-center mb20"
};

var _hoisted_2 = /*#__PURE__*/_createTextVNode("我有权限的");

var _hoisted_3 = /*#__PURE__*/_createTextVNode("我创建的");

var _hoisted_4 = {
  class: "mb20 flex-v-center"
};

var _hoisted_5 = /*#__PURE__*/_createTextVNode(" 我所在的角色组： ");

var _hoisted_6 = ["onClick"];

var _hoisted_7 = /*#__PURE__*/_createTextVNode(" 想要获取更多功能权限？可至“");

var _hoisted_8 = /*#__PURE__*/_createTextVNode("”查看并申请其他角色组 ");

import authWrap from './components/authWrap.vue';
import AuthService from '@/api/auth';
import { useRouter, useRoute } from 'vue-router';
import commonTable from './components/commonTable';
import DtMessage from '@/components/DtMessage';
import { ref, reactive, onMounted, watch, computed } from 'vue';
import { useStore } from 'vuex';
import { asyncComputed } from '@vueuse/core';
import { getAuthListConfig } from './commons/authUtil';
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var route = useRoute();
    var tabValue = ref('content');
    var myFieldType = ref('1');
    var router = useRouter();
    var searchParams = reactive({
      appKey: route.params.project || 'beacon_olap',
      bizId: route.params.biz_url,
      assetQueryMode: 'ONLY_PERM',
      creator: '',
      dataAssetAction: 'EXE',
      assetKey: '',
      keyword: '',
      pageNo: 1,
      pageSize: 10
    });
    var tableOptions = reactive({
      loading: false,
      pagination: true,
      total: 0,
      noExpand: true
    });
    var tableHeader = ref([{
      title: 'ID',
      key: 'id',
      width: 100
    }, {
      title: '数据资产内容',
      key: 'name',
      preIcon: 'FolderOpened',
      iconShowKey: 'dir',
      iconShowValue: true
    }, {
      title: '路径',
      key: 'location'
    }]);
    var tableBody = ref([]);
    var dataTypes = ref([]);
    var myRoleList = ref([]);
    var store = useStore();
    var userDetail = computed(function () {
      return store.state.user.userDetail;
    });
    var loginName = computed(function () {
      return store.state.user.userDetail.login_name;
    });
    var loginId = computed(function () {
      return store.state.user.userDetail.id;
    });
    var appKey = computed(function () {
      return route.params.project;
    }); // 权限类型配置

    var authTypeList = asyncComputed(function () {
      return getAuthListConfig({
        appKey: searchParams.appKey,
        categoryKey: searchParams.assetKey
      });
    }); // 列表权限回显

    var getRoleType = function getRoleType(key) {
      return authTypeList.value.find(function (authType) {
        return authType.key === key;
      }).desc;
    };

    var searchList = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(params) {
        var _data$data;

        var data, result, _data$data2;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                tableOptions.loading = true;
                if (params === undefined) searchParams.pageNo = 1;
                if (params !== null && params !== void 0 && params.pageNo) searchParams.pageNo = params.pageNo;
                if (params !== null && params !== void 0 && params.pageSize) searchParams.pageSize = params.pageSize;
                _context.next = 6;
                return AuthService.queryAssetByPage(_objectSpread(_objectSpread({}, searchParams), params));

              case 6:
                data = _context.sent;

                if (((_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.code) === 1) {
                  result = data.data.result;
                  tableOptions.total = result.totalCount || 0;
                  tableBody.value = result.itemList || [];
                } else {
                  tableOptions.total = 0;
                  tableBody.value = [];
                  DtMessage({
                    type: 'warning',
                    message: (_data$data2 = data.data) === null || _data$data2 === void 0 ? void 0 : _data$data2.msg
                  });
                }

                tableOptions.loading = false;

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function searchList(_x) {
        return _ref.apply(this, arguments);
      };
    }();

    var getMyRole = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _data$data3;

        var data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return AuthService.getMyRoleList({
                  bizId: searchParams.bizId,
                  appKey: searchParams.appKey
                });

              case 2:
                data = _context2.sent;

                if (((_data$data3 = data.data) === null || _data$data3 === void 0 ? void 0 : _data$data3.code) === 1) {
                  myRoleList.value = data.data.result;
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function getMyRole() {
        return _ref2.apply(this, arguments);
      };
    }();

    var initData = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _data$data4, _dataTypes$value;

        var data;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return AuthService.getListBaseInfoByAppkey({
                  appKey: searchParams.appKey
                });

              case 2:
                data = _context3.sent;

                if (((_data$data4 = data.data) === null || _data$data4 === void 0 ? void 0 : _data$data4.code) === 1) {
                  dataTypes.value = data.data.result;
                }

                if (!(((_dataTypes$value = dataTypes.value) === null || _dataTypes$value === void 0 ? void 0 : _dataTypes$value.length) > 0)) {
                  _context3.next = 10;
                  break;
                }

                searchParams.assetKey = dataTypes.value[0].assetKey;
                _context3.next = 8;
                return searchList();

              case 8:
                _context3.next = 13;
                break;

              case 10:
                searchParams.assetKey = '';
                tableBody.value = [];
                dataTypes.value = [];

              case 13:
                _context3.next = 15;
                return getMyRole();

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function initData() {
        return _ref3.apply(this, arguments);
      };
    }();

    var radioChangeHandler = function radioChangeHandler(val) {
      if (val === '2') {
        searchParams.creator = loginId.value;
      } else {
        searchParams.creator = '';
      }

      searchList();
    };

    var jumpToRoleGroup = function jumpToRoleGroup(id) {
      router.push("/authority/".concat(searchParams.bizId, "/authRoleGroup/").concat(searchParams.appKey, "/").concat(id));
    };

    watch(function () {
      return appKey.value;
    }, function (newKey) {
      if (newKey) {
        searchParams.appKey = newKey || 'beacon_olap';
        initData();
      }
    });
    onMounted(function () {
      initData();
    });
    return function (_ctx, _cache) {
      var _component_el_radio_button = _resolveComponent("el-radio-button");

      var _component_el_radio_group = _resolveComponent("el-radio-group");

      var _component_el_option = _resolveComponent("el-option");

      var _component_el_select = _resolveComponent("el-select");

      var _component_el_input = _resolveComponent("el-input");

      var _component_el_table_column = _resolveComponent("el-table-column");

      var _component_el_tab_pane = _resolveComponent("el-tab-pane");

      var _component_el_tabs = _resolveComponent("el-tabs");

      return _openBlock(), _createBlock(authWrap, {
        "search-params": _unref(searchParams)
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_tabs, {
            modelValue: tabValue.value,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
              return tabValue.value = $event;
            }),
            type: "border-card"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_tab_pane, {
                label: "数据资产权限",
                name: "content"
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_radio_group, {
                    class: "w250",
                    modelValue: myFieldType.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                      return myFieldType.value = $event;
                    }),
                    onChange: radioChangeHandler
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_el_radio_button, {
                        label: "1"
                      }, {
                        default: _withCtx(function () {
                          return [_hoisted_2];
                        }),
                        _: 1
                      }), _createVNode(_component_el_radio_button, {
                        label: "2"
                      }, {
                        default: _withCtx(function () {
                          return [_hoisted_3];
                        }),
                        _: 1
                      })];
                    }),
                    _: 1
                  }, 8, ["modelValue"]), _createVNode(_component_el_input, {
                    class: "w500 ml10 input-with-select",
                    placeholder: "请输入数据资产名称或ID进行搜索",
                    modelValue: _unref(searchParams).keyword,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
                      return _unref(searchParams).keyword = $event;
                    }),
                    onChange: _cache[4] || (_cache[4] = function ($event) {
                      return searchList();
                    }),
                    clearable: ""
                  }, {
                    prepend: _withCtx(function () {
                      return [_createVNode(_component_el_select, {
                        modelValue: _unref(searchParams).assetKey,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                          return _unref(searchParams).assetKey = $event;
                        }),
                        class: "w150",
                        onChange: _cache[2] || (_cache[2] = function ($event) {
                          return searchList();
                        }),
                        placeholder: "选择资产类型"
                      }, {
                        default: _withCtx(function () {
                          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataTypes.value, function (item) {
                            return _openBlock(), _createBlock(_component_el_option, {
                              label: item.assetName,
                              value: item.assetKey,
                              key: item.assetKey
                            }, null, 8, ["label", "value"]);
                          }), 128))];
                        }),
                        _: 1
                      }, 8, ["modelValue"])];
                    }),
                    _: 1
                  }, 8, ["modelValue"])]), _createVNode(_unref(commonTable), {
                    params: _unref(searchParams),
                    options: _unref(tableOptions),
                    "table-header": tableHeader.value,
                    "table-body": tableBody.value,
                    onOnChangePage: searchList
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_el_table_column, {
                        label: "权限类型",
                        width: "100"
                      }, {
                        default: _withCtx(function (scope) {
                          return [_createTextVNode(_toDisplayString(getRoleType(scope.row.dataAssetAction)), 1)];
                        }),
                        _: 1
                      })];
                    }),
                    _: 1
                  }, 8, ["params", "options", "table-header", "table-body"])];
                }),
                _: 1
              }), _createVNode(_component_el_tab_pane, {
                label: "角色组权限",
                name: "role"
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", _hoisted_4, [_hoisted_5, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(myRoleList.value, function (item, idx) {
                    return _openBlock(), _createElementBlock("div", {
                      class: "role-btn",
                      key: idx,
                      onClick: function onClick() {
                        return jumpToRoleGroup(item.id);
                      },
                      target: "_blank"
                    }, _toDisplayString(item.name), 9, _hoisted_6);
                  }), 128))]), _createElementVNode("div", null, [_hoisted_7, _createElementVNode("a", {
                    class: "link1",
                    onClick: _cache[5] || (_cache[5] = function ($event) {
                      return _ctx.$router.push({
                        name: 'AuthRoleGroup',
                        params: {
                          project: _unref(searchParams).appKey
                        }
                      });
                    })
                  }, "权限中心-空间权限-申请角色组权限"), _hoisted_8])];
                }),
                _: 1
              })];
            }),
            _: 1
          }, 8, ["modelValue"])];
        }),
        _: 1
      }, 8, ["search-params"]);
    };
  }
});